import { Routes } from '@angular/router';
import { authGuard } from '../auth/auth.guard';
import { AiBrokerChatComponent } from './ai-broker-chat.component';
import { LoadDetailsComponent } from '../loads/load-details/load-details.component';

export const AI_BROKER_ROUTES: Routes = [
  {
    path: 'ai-broker',
    component: AiBrokerChatComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'load-details/:id',
        component: LoadDetailsComponent,
        outlet: 'canvas'
      },
      {
        path: 'matches/:id',
        loadComponent: () => import('../matches/match-details/match-details.component').then(m => m.MatchDetailsComponent),
        outlet: 'canvas'
      },
      {
        path: 'shipments/:id',
        loadComponent: () => import('../shipments/shipment-details/shipment-details.component').then(m => m.ShipmentDetailsComponent),
        outlet: 'canvas'
      },
      {
        path: 'availability-details/:id',
        loadComponent: () => import('../availabilities/availability-details/availability-details.component').then(m => m.AvailabilityDetailsComponent),
        outlet: 'canvas'
      }
    ]
  }
];
